import { useDispatch, useSelector } from "react-redux";
import {
  currentlyEditingSleeperSelector,
  setCurrentStepDoubleSleeperMattressBuilder,
  setCurrentlyEditingSleeper,
  setIsSummaryModalOpen,
} from "../../../../redux/slices/customNavigation";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import BackgroundStepNumber from "../../SingleBedBuilder/common/BackgroundStepNumber";
import BedBuilderHeader from "../../SingleBedBuilder/common/BedBuilderHeader";
import BedBuilderNextButton from "../../SingleBedBuilder/common/BedBuilderNextButton";
import PainPointSelection from "../../SingleBedBuilder/PainPoints/PainPointSelection";

import React from "react";

import {
  mattressConfigurationSelector,
  updateMattressConfiguration,
} from "../../../../redux/slices/mattressConfiguration";
import {
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../../../redux/slices/customer";
import { saveMattressConfigurationToLocalStorage } from "../../../../utils/bedBuilder.utils";
import FirmnessSlider from "../../SingleBedBuilder/Firmness/FirmnessSlider";
import SleeperSelectorButtons from "../common/SleeperSelectorButtons";

import styled from "styled-components";

const StyledContentContainer = styled.div`
  position: relative;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const StyledSettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const StyledSleeperButtonsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 17%;
  height: 100%;
  padding-top: 20%;
  z-index: 200;
`;

const StyledRawContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 83%;
  height: 100%;
`;

const StyledSleeperSelectContainer = styled.div``;

const DoubleSleeperFirmnessPreference = ({ currentStep }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);

  const handleUpdateMattressConfiguration = () => {
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };

  return (
    <StyledSleeperSelectContainer>
      <StyledSleeperButtonsContainer>
        <SleeperSelectorButtons
          editingSleeper1={editingSleeper1}
        ></SleeperSelectorButtons>
        <BackgroundStepNumber
          styles={{
            marginTop: editingSleeper1 ? "-39vh" : "-21vh",
            transition: "marginTop 300ms ease-in-out 0s",
            // marginLeft: "-7vw",
          }}
        >
          {t("4")}
        </BackgroundStepNumber>
      </StyledSleeperButtonsContainer>

      <StyledRawContainer className={"firmness-preference-panel"}>
        <StyledContentContainer
          style={{
            zIndex: 1000,
            borderRadius: "0 0 0 60px",
            borderColor: "transparent",
            background:
              "transparent linear-gradient(0deg, #e1f4fd 0%,  #FFFFFF 100%) 0% 0% no-repeat padding-box",
          }}
        >
          <BedBuilderHeader
            styles={{
              marginTop: "7vh",
              marginBottom: "3vh",
              paddingRight: "2vw",
              paddingLeft: "2vw",
              textAlign: "center",
            }}
          >
            {t("Do you have a preference on the way your bed feels?")}
          </BedBuilderHeader>
          <FirmnessSlider></FirmnessSlider>
          <StyledSettingsContainer className="mx-2">
            <BedBuilderNextButton
              styles={{
                position: "absolute",
                bottom: "5%",
                right: "5%",
              }}
              onClick={() => {
                //Update in local storage
                // console.log("saving to local storage");
                saveMattressConfigurationToLocalStorage(mattressConfiguration);
                handleUpdateMattressConfiguration();
                if (editingSleeper1) {
                  dispatch(setCurrentlyEditingSleeper(2));
                } else {
                  // dispatch(setCurrentlyEditingSleeper(1));
                  dispatch(setIsSummaryModalOpen(true));
                  dispatch(
                    setCurrentStepDoubleSleeperMattressBuilder(currentStep + 1)
                  );
                }
              }}
            ></BedBuilderNextButton>
          </StyledSettingsContainer>
        </StyledContentContainer>
      </StyledRawContainer>
    </StyledSleeperSelectContainer>
  );
};

export default DoubleSleeperFirmnessPreference;
